<template>
  <div class="rightModal">
    <Input
      label="servers.snapshotName"
      placeholder="servers.enterSnapshotName"
      id="snapshotName"
      v-model="form.snapshotName"
      :state="validateState('snapshotName')"
    />

    <div class="info" v-html="$t('servers.snapshotInfo')"></div>

    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </b-card>
      </template>

      <div
        v-if="estimates && estimates.length > 0"
        class="estimate-info"
        v-for="est in estimates"
        :key="est.id"
      >
        <InfoBox>
          <div class="estTitle">{{ est.diskName }}</div>
          <span class="text" v-if="est.total_price"
            >{{ $t('global.price') }}: {{ est.total_price }} $</span
          >
          <ul v-if="est.info && est.info.length > 0">
            <li class="mb-3" v-for="(item, index) in est.info" :key="index">
              {{ item }}
            </li>
          </ul>
        </InfoBox>
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'TakeSnapshot',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    total_disk: Number | String,
    vmData: Array | Object,
  },
  data() {
    return {
      form: {
        snapshotName: '',
      },
      loading: false,
      estimates: [],
    }
  },
  validations: {
    form: {
      snapshotName: {
        required,
      },
    },
  },
  created() {
    this.getDisks()
  },
  methods: {
    getDisks() {
      this.getDiskInfo().then((res) => {
        if (res && res.data) {
          res.data.forEach((data) => {
            this.getEstimate(data)
          })
        }
      })
    },
    getDiskInfo() {
      this.loading = true

      return new Promise((resolve, reject) => {
        ApiService.get(
          `iaas/virtual-disk-images?virtualMachine=${this.vmData.id}&position=id|desc`
        )
          .then(({ data }) => {
            this.loading = false
            resolve(data)
          })
          .catch((err) => {
            this.loading = false
            reject(err)
          })
      })
    },
    getEstimate(disk) {
      this.loading = true
      this.getEstimateInfo(disk.id).then((res) => {
        if (res) {
          let c = res
          c.diskName = disk.name
          this.estimates.push(c)
          this.loading = false
        }
      })
    },
    getEstimateInfo(diskId) {
      let params = {
        hdd_size: this.$customFunctions.convertMBtoGB(this.total_disk),
        disk: diskId, //this.$route.params.id,
      }

      return new Promise((resolve, reject) => {
        ApiService.post(`billing/iaas/virtual-disk/estimate`, params)
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        name: this.form.snapshotName,
      }
      ApiService.post(
        `iaas/virtual-machines/${this.vmData.id}/snapshot`,
        params
      )
        .then(({ data }) => {
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          // this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.estimate-info {
  font-size: 12px;
  ul {
    margin-top: 10px;
  }
  .estTitle {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
  }
}
</style>
